import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoadErrorScreen } from "../../../screens/invoices/shared";
import { NotificationsSettingsScreen } from "../../../screens/settings/notifications/notifications-screen";
import { notificationSettingsQuery } from "../../../screens/settings/notifications/queries";

/** Admin + manager (`notifications:manage`); anyone else is bounced to the dashboard. */
export const Route = createFileRoute("/_authed/settings/notifications")({
  beforeLoad: ({ context }) => {
    if (!can(context.session.role, "notifications:manage")) throw redirect({ to: "/" });
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(notificationSettingsQuery),
  errorComponent: () => <LoadErrorScreen title={t.notificationsSettings.title} />,
  component: () => {
    const { session } = Route.useRouteContext();
    return <NotificationsSettingsScreen userEmail={session.email} />;
  },
});
